import { useEffect } from "react";
import { useSelector } from "react-redux";
import useMultiNotification from "../../hooks/useNotification";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
// import ChatSidebar from "./ChatSideBar";
import { getMyChats } from "../../redux-toolkit/slices/chatSlice";
import ChatWindow from "./ChatWindow";
import "./chat.css";
export default function ChatApp() {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();

  const { error, isSubmitting } = useSelector((state: RootState) => state.chat);
  const { userProfile } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(getMyChats());
  }, []);

  return (
    <div className="chat-container">
      {/* <ChatSidebar /> */}
      <ChatWindow />
    </div>
  );
}
